import { createSelector } from "@ngrx/store";
import { LoadingState, State } from "@state/models";
import { ImageProfileState } from "./models";

const slice = (state: State) => state.imageProfile;

export const isLoading = createSelector(slice,
  (state: ImageProfileState) => state.state === LoadingState.loading
);

export const isLoaded = createSelector(slice,
  (state: ImageProfileState) => state.state === LoadingState.loaded
);

export const error = createSelector(slice,
  (state: ImageProfileState) => state.error
);

export const imageProfiles = createSelector(slice,
  (state: ImageProfileState) => state.items
);

export default {
  isLoading,
  isLoaded,
  error,
  imageProfiles
};
